import React, { useState, useEffect } from "react";
import { FileText, IndianRupee, Sparkles, Loader2 } from "lucide-react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import graphqlRequest from "../../requestMethod";
import "./JobDescriptionCosts.scss";

const JobDescriptionCosts = ({
  jobDescription,
  onJobDescriptionChange,
  shiftConfig,
  professionalDetails,
  generateJobDescription,
  isGenerating,
  setTotalCost,
  clickCount,
}) => {
  // Fetch actual shifts from the server
  //  const { data: shifts = [], isLoading: shiftsLoading } = {};

  const [groupedJobs, setGroupedJobs] = useState([]);
  const [totalShiftCount, setTotalShiftCount] = useState(0);
  const [overallSummary, setOverallSummary] = useState({
    hospital: 0,
    margin: 0,
    gst: 0,
    total: 0,
  });
  const [descriptionData, setDescriptionData] = useState("");

  // const [isGenerating, setIsGenerating] = useState(false);

  let loginData = localStorage.getItem("auth");
  let token = JSON.parse(loginData)?.accessToken;

  // console.log("professionalDetails", professionalDetails);
  const queryClient = useQueryClient();

  const { data: shifts = [], isLoading: shiftsLoading } = useQuery({
    queryKey: ["/api/shifts"],
    queryFn: async () => {
      const response = await fetch("/api/shifts");
      if (!response.ok) throw new Error("Failed to fetch shifts");
      return response.json();
    },
  });

  // const generateJobDescription = ""

  //   const generateJobDescription = useMutation({
  //     mutationFn: async () => {
  //       // Validate that we have enough professional details
  //       if (!professionalDetails.profession || !professionalDetails.department) {
  //         throw new Error(
  //           "Please select profession and department before generating job description"
  //         );
  //       }

  //       const response = await fetch("/api/ai/generate-job-description", {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({
  //           professionalDetails,
  //           shiftConfig,
  //         }),
  //       });

  //       if (!response.ok) throw new Error("Failed to generate job description");
  //       return response.json();
  //     },
  //     onSuccess: (data) => {
  //       onJobDescriptionChange(data.jobDescription);
  //     },
  //   });

  //  function generateJobDescription() {
  //    setIsGenerating(true); // Start loading

  //    const query = `
  //     query {
  //       withAuth(token: "${token}") {
  //         generateJD(
  //           profession: "${professionalDetails?.profession}",
  //           department: "${professionalDetails?.department}",
  //           experience: "${professionalDetails?.experience}",
  //           specialization: "${professionalDetails?.specialization}",
  //           qualification: "${professionalDetails?.qualification}"
  //         ) {
  //           jobDescription
  //         }
  //       }
  //     }
  //   `;

  //    graphqlRequest(query)
  //      .then((response) => {
  //       //  console.log("responseDescription>>", response);
  //        setDescriptionData(
  //          response?.data?.withAuth?.generateJD?.jobDescription || ""
  //        );
  //      })
  //      .catch((err) => {
  //        console.error("JD generation failed:", err);
  //      })
  //      .finally(() => {
  //        setIsGenerating(false); // Stop loading
  //      });
  //  }

  console.log("shifts in costs2", shifts);

  const calculateCostDetails = () => {
    // console.log("jobDescription", shifts);
    if (!shifts || shifts.length === 0) {
      return {
        totalJobs: 0,
        totalShifts: 0,
        professionalCharges: 0,
        convenienceFees: 0,
        taxes: 0,
        totalCost: 0,
      };
    }

    // Group shifts by job characteristics
    const jobGroups = new Map();
    const totalShifts = shifts.length;

    shifts.forEach((shift) => {
      // Calculate end time for grouping
      const startTime = shift.startTime;
      const [hours, minutes] = startTime.split(":").map(Number);
      const endTime = new Date();
      endTime.setHours(hours + shift.duration, minutes, 0, 0);
      const endTimeStr = endTime.toTimeString().slice(0, 5);

      const jobKey = `${shift.startDate}-${shift.startTime}-${shift.startDate}-${endTimeStr}-${shift.campDuty}-${shift.rateOffered}`;

      if (!jobGroups.has(jobKey)) {
        jobGroups.set(jobKey, []);
      }
      jobGroups.get(jobKey).push(shift);
    });

    const totalJobs = jobGroups.size;
    const totalFinalJobs = jobGroups;

    // Calculate professional charges from all shifts
    const professionalCharges = shifts.reduce((sum, shift) => {
      const shiftRate = parseFloat(shift.rateOffered) || 0;
      return sum + shift.professionalCount * shiftRate * shift.duration;
    }, 0);

    const convenienceFees = professionalCharges * 0.12; // 12% convenience fees
    const taxes = convenienceFees * 0.18; // 18% taxes on convenience fees only
    const totalCost = professionalCharges + convenienceFees + taxes;

    return {
      totalJobs,
      totalShifts,
      professionalCharges: parseFloat(professionalCharges.toFixed(2)),
      convenienceFees: parseFloat(convenienceFees.toFixed(2)),
      taxes: parseFloat(taxes.toFixed(2)),
      totalCost: parseFloat(totalCost.toFixed(2)),
      totalFinalJobs,
    };
  };

  const costDetails = calculateCostDetails();
  // console.log("costDetails", costDetails?.totalFinalJobs);

  const groupShiftsIntoJobs = (shifts) => {
    const jobsMap = new Map();

    for (const shift of shifts) {
      const jobKey = `${shift.startDate}-${shift.startTime}-${shift.endDate}-${shift.endTime}-${shift.campDuty}-${shift.rateOffered}`;

      if (!jobsMap.has(jobKey)) {
        jobsMap.set(jobKey, {
          ...shift,
          professionalCount: shift.professionalCount,
          groupedShifts: [shift],
        });
      } else {
        const job = jobsMap.get(jobKey);
        job.groupedShifts.push(shift);
        job.professionalCount += shift.professionalCount;
      }
    }

    const result = Array.from(jobsMap.values());
    return result.map((job) => {
      delete job.groupedShifts;
      return job;
    });
  };

  //  function countRecurringDaysBetween(start, end, recurringDays = []) {
  //   console.log("start", start);
  //   console.log("end", end);
  //   console.log("recurringDays2", recurringDays);
  //    const startDate = new Date(start);
  //    const endDate = new Date(end);
  //    let count = 0;

  //    const shortDayNameToIndex = {
  //      Sun: 0,
  //      Mon: 1,
  //      Tue: 2,
  //      Wed: 3,
  //      Thu: 4,
  //      Fri: 5,
  //      Sat: 6,
  //    };

  //    const dayIndexes = recurringDays.map((day) => shortDayNameToIndex[day]);
  //    console.log("dayIndexes", dayIndexes);
  //    for (let d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
  //      if (dayIndexes.includes(d.getDay())) {
  //        count++;
  //      }
  //    }

  //    console.log("count", count);
  //    return count;
  //  }

  let fetchLocumJobRate = async () => {
    setOverallSummary({
      hospital: 0,
      margin: 0,
      gst: 0,
      total: 0,
      marginPercentage: 0,
    });
    setTotalCost({
      hospital: 0,
      margin: 0,
      gst: 0,
      total: 0,
      marginPercentage: 0,
    });

    const groupedJobs = await groupShiftsIntoJobs(shifts || []);

    console.log("groupedJobs in cost", groupedJobs);
    setGroupedJobs(groupedJobs.length);
    setTotalShiftCount(shifts.length);

    let totalHospital = 0;
    let totalMargin = 0;
    let totalGst = 0;
    let totalSum = 0;
    let marginPercentage = 0;
    for (const job of groupedJobs) {
      const {
        hospital,
        department,
        profession,
        qualification,
        specialization,
        experience,
        rateOffered,
        professionalCount,
        startDate,
        endDate,
        startTime,
        endTime,
        recurringDays,
        shiftType,
        duration,
      } = job;
      // Calculate days
      const days = shiftType === "NON_CONSECUTIVE" ? 1 : 1;

      // console.log("days", days);

      const query = `
      query {
        withAuth(token: "${token}") {
          getMiniJobCostV1(
            branch: "${hospital}"
            department: "${department}"
            profession: "${profession}"
            qualification: "${qualification}"
            specialization: "${specialization}"
            experience: "${experience}"
            maxRate: ${rateOffered}
            applicants: ${professionalCount}
            days: ${days}
            startTime: "${startTime}"
            endTime: "${endTime}"
            duration: ${duration}
            
          ) {
            shift
            nurse
            hospital
            margin
            gst
            total
            marginPercentage
          }
        }
      }
    `;
      // console.log("query", query);
      try {
        const response = await graphqlRequest(query);
        console.log("responseLocumJobRate", response);
        const cost = response?.data?.withAuth?.getMiniJobCostV1;
        console.log(`Cost for job [${startDate} - ${endDate}]:`, cost);
        // setTotalCost(cost);
        totalHospital += cost.hospital || 0;
        totalMargin += cost.margin || 0;
        totalGst += cost.gst || 0;
        totalSum += cost.total || 0;
        marginPercentage = cost.marginPercentage || 0;
      } catch (err) {
        console.error("Error fetching job cost for job:", job, err);
      }
    }

    const summary = {
      hospital: totalHospital,
      margin: totalMargin,
      gst: totalGst,
      total: totalSum,
      marginPercentage,
    };

    setOverallSummary(summary);
    setTotalCost(summary);
  };
console.log("costShifts", shifts);
const extractRelevantFields = (shifts) => {
  return shifts.map((shift) => ({
    hospital: shift.hospital,
    department: shift.department,
    profession: shift.profession,
    qualification: shift.qualification,
    specialization: shift.specialization,
    experience: shift.experience,
    rateOffered: shift.rateOffered,
    professionalCount: shift.professionalCount,
    startTime: shift.startTime,
    endTime: shift.endTime,
    duration: shift.duration,
  }));
};

const relevantShiftHash = JSON.stringify(extractRelevantFields(shifts));
useEffect(() => {
  if (shifts?.length) {
    fetchLocumJobRate();
  }
}, [relevantShiftHash]);
  // useEffect(() => {
  //   if (shifts?.length) {
  //     fetchLocumJobRate();
  //   }
  // }, [shifts]);

  console.log("overallSummary", overallSummary);
  // console.log("jobDescription", jobDescription);
  return (
    <div className="grid grid-2 job-description-costs">
      {/* Job Description */}
      <div className="card-modern card-hover">
        <div className="p-6">
          <div
            className="component-header"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div className="icon-container">
              <FileText size={20} />
            </div>
            <h2 style={{ margin: 0 }}>Job Description</h2>

            <button
              onClick={generateJobDescription}
              disabled={
                isGenerating ||
                clickCount >= 2 ||
                !professionalDetails.profession ||
                !professionalDetails.department
              }
              className="btn btn-outline-accent btn-sm"
              style={{ marginLeft: "auto" }}
            >
              {isGenerating ? (
                <>
                  <Loader2 className="icon spinner" />
                  Generating...
                </>
              ) : (
                <>
                  <Sparkles className="icon" />
                  Generate with AI
                </>
              )}
            </button>
          </div>

          <div className="description-section">
            <textarea
              value={(() => {
                try {
                  const parsed = JSON.parse(jobDescription);
                  const cleanText =
                    typeof parsed === "string" ? parsed : jobDescription;
                  return cleanText.replace(/\*/g, "");
                } catch (e) {
                  return jobDescription;
                }
              })()}
              // onChange={(e) => onJobDescriptionChange(e.target.value)}
              onChange={(e) => {
                onJobDescriptionChange(e.target.value);
                const existingShifts =
                  queryClient.getQueryData(["/api/shifts"]) || [];

                const updatedShifts = existingShifts.map((shift) => ({
                  ...shift,
                  jobDescription: e.target.value,
                }));

                queryClient.setQueryData(["/api/shifts"], updatedShifts);
              }}
              className="textarea description-textarea"
              placeholder="Enter detailed job description, requirements, and special instructions... or click 'Generate with AI' to auto-create based on professional details."
              rows={8}
            />
            <p className="help-text">
              Fill in the professional details above first, then click "Generate
              with AI" for an automated job description.
            </p>
          </div>
        </div>
      </div>

      {/* Cost Details */}
      <div className="card-modern card-hover">
        <div className="p-6">
          <div className="component-header">
            <div className="icon-container">
              <IndianRupee size={20} />
            </div>
            <h2>Cost Details</h2>
          </div>
          <div className="cost-section">
            {
              // shiftsLoading ? (
              //   <div className="loading-state">
              //     <div className="loading-content">
              //       <Loader2 className="spinner" />
              //       <span>Loading cost details...</span>
              //     </div>
              //   </div>
              // ) :

              shifts.length === 0 ? (
                <div className="empty-state">
                  <div className="empty-content">
                    <span>
                      No shifts created yet. Generate shifts to see cost
                      breakdown.
                    </span>
                  </div>
                </div>
              ) : (
                <div className="cost-breakdown">
                  <div className="cost-header">
                    <span className="cost-title">Total Cost for</span>
                    <span className="cost-summary">
                      {groupedJobs} Jobs ({totalShiftCount} shifts)
                    </span>
                  </div>

                  <div className="cost-items">
                    <div className="cost-item">
                      <span className="cost-label">Professional Charges</span>
                      <span className="cost-value">
                        ₹{overallSummary?.hospital?.toLocaleString()}
                      </span>
                    </div>

                    <div className="cost-item">
                      <span className="cost-label">
                        Convenience Fees ({overallSummary?.marginPercentage}%)
                      </span>
                      <span className="cost-value">
                        ₹{overallSummary?.margin?.toLocaleString()}
                      </span>
                    </div>

                    <div className="cost-item">
                      <span className="cost-label">
                        Taxes (18% on convenience fees)
                      </span>
                      <span className="cost-value">
                        ₹{overallSummary?.gst?.toLocaleString()}
                      </span>
                    </div>

                    {/* <div className="cost-divider"></div> */}

                    <div className="cost-item total">
                      <span className="cost-label">Total Amount</span>
                      <span className="cost-value">
                        ₹{overallSummary?.total?.toLocaleString()}
                      </span>
                    </div>
                  </div>

                  {/* <div className="cost-note">
                  <p>
                    * Taxes are calculated only on convenience fees as per
                    regulations
                  </p>
                </div> */}
                </div>
              )
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobDescriptionCosts;
